import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { SgoSituacoesDemanda } from 'src/app/modules/projeto-completo/models/sgo-situacoes-demanda';
import { SgoSituacoesDemandaService } from 'src/app/modules/projeto-completo/services/sgo-situacoes-demanda.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-sgo-situacoes-demanda-list',
  templateUrl: './sgo-situacoes-demanda-list.component.html',
  styleUrls: ['./sgo-situacoes-demanda-list.component.scss'],
})
export class SgoSituacoesDemandaListComponent extends BaseListComponent<SgoSituacoesDemanda> implements OnInit, OnDestroy {

  sgoSituacoesList: SgoSituacoesDemanda[];

  constructor(
    private myService: SgoSituacoesDemandaService,
    private router: Router,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.sgoSituacoesList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/projetos/admin-spgg/sgo-situacoes-demanda/adicionar'];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: any): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error);
      }
    });
  }

  editar(id: number) {
    return ['/projetos/admin-spgg/sgo-situacoes-demanda/', id];
  }
}
